'use client';

import Grid from '@mui/material/Grid';

import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import { ComponentBlocksText, Enum_Componentshareddisplayoptions_Contentswidth } from '@/types';

import GlobalBlockRenderer from '../GlobalBlockRenderer/GlobalBlockRenderer';

export function TextBlock({
  blocks,
  paddingInline,
}: {
  blocks: ComponentBlocksText;
  paddingInline?: StrapiDisplayOptions['PaddingInline'];
}) {
  const displayOptions = {
    ContentsWidth: Enum_Componentshareddisplayoptions_Contentswidth.Wide,
    PaddingTop: 'md',
    PaddingBottom: 'md',
    PaddingInline: 'sm',
    ...(blocks?.TextBlockDisplayOptions ?? {}),
    ...(paddingInline ? { PaddingInline: paddingInline } : {}),
  } as StrapiDisplayOptions;

  return (
    <CustomBackground
      backgroundOptions={(blocks?.TextBlockBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={displayOptions}
      boxProps={{
        // @ts-expect-error - this does work, but types are not correct
        'data-component': 'TextBlock',
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          md={blocks.Columns}
          sx={{
            ml: { md: blocks.Offset ? `${blocks.Offset * 8.333333}%` : 0 },
          }}
        >
          <GlobalBlockRenderer content={blocks.Body || []} />
        </Grid>
      </Grid>
    </CustomBackground>
  );
}
